<template>
  <v-dialog
    v-model="parentPortalPresentationModelDialog"
    persistent
    max-width="300"
  >
    <v-card>
      <v-form ref="portalConfigurationFormRef">
        <v-card-title class="primary-background">
          <span>Modèle du portail</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="parentPortalPresentationModelDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div id="portal-form">
              <v-row>
                <v-col
                  cols="12"
                  v-if="
                    !isPortalProfile && ((isGroup && !builtInProxy) || !isGroup)
                  "
                >
                  <v-select
                    :items="portalModels"
                    item-text="name"
                    item-value="id"
                    label="Modèle"
                    v-model="formData.model_id"
                    :disabled="formData.is_inherit || builtInProxy"
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" v-if="group != null" class="pt-0">
                  <v-checkbox
                    :disabled="group.portal != 3 || builtInProxy"
                    v-model="formData.is_inherit"
                    label="Héritage groupe"
                    :hint="
                      group.portal != 3
                        ? 'Le groupe doit être migré en V5 pour hériter de sa configuration'
                        : ''
                    "
                    :persistent-hint="group.portal != 3"
                    :hide-details="group.portal == 3"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-checkbox
                    v-model="builtInProxy"
                    label="Template prédéfini"
                    :disabled="formData.is_inherit || isPortalProfile"
                    hide-details
                  ></v-checkbox>
                  <v-select
                    v-model="portalProfile"
                    return-object
                    label="Liste des templates définis"
                    :items="portalProfiles"
                    item-value="id"
                    item-text="name"
                    :disabled="!builtInProxy"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="parentPortalPresentationModelDialog = false"
          >
            Fermer
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="triggerUpdate"
            :loading="loadingUpdate"
          >
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { usePortalModel } from "../../composables/portal-model";
import { usePortalProfile } from "../../composables/portal-profile";

export default {
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    isGroup: Boolean,
    updatePortalConfiguration: Function,
    id: String,
    group: Object,
    partner: Object,
    portalOptionsId: Number,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    portalPresentationModelDialog: Boolean,
    isPortalProfile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    /* Import des API */
    const { listPortalModels, portalModels } = usePortalModel();
    const { portalProfiles, listPortalProfileV5 } = usePortalProfile();
    const portalProfile = ref(null);

    const formData = ref({
      model_id: props.portalConfiguration.model_id,
      is_inherit: props.isInherit,
    });

    onMounted(async () => {
      listPortalModels();
      await listPortalProfileV5(props.partner.id);
      if (props.isBuiltIn == true) {
        portalProfile.value = portalProfiles.value.find(
          (profile) => profile.portalOptions.id == props.portalOptionsId
        );
        if (portalProfile.value != null) {
          formData.value.builtin_id = portalProfile.value.id;
        }
      }
    });

    /* Variables */
    const builtInProxy = ref(props.isBuiltIn);
    const loadingUpdate = ref(false);

    /* Computed */
    const parentPortalPresentationModelDialog = computed({
      get: () => props.portalPresentationModelDialog,
      set: (value) => {
        emit("update:portalPresentationModelDialog", value);
      },
    });

    watch(
      () => builtInProxy.value,
      (newValue, oldValue) => {
        if (newValue != oldValue && newValue == false) {
          delete formData.value.builtin_id;
          formData.value.model_id = portalModels.value[0].id;
        }
      }
    );

    /* Méthodes */
    const triggerUpdate = async function () {
      if (portalProfile.value != null && builtInProxy.value == true) {
        formData.value.builtin_id = portalProfile.value.id;
      }
      loadingUpdate.value = true;
      await props.updatePortalConfiguration(props.id, formData.value);
      loadingUpdate.value = false;
    };

    return {
      portalProfiles,
      portalProfile,
      parentPortalPresentationModelDialog,
      portalModels,
      builtInProxy,
      formData,
      loadingUpdate,
      triggerUpdate,
    };
  },
};
</script>
